import React, {
  Dispatch,
  SetStateAction
} from 'react'
import { Button } from 'semantic-ui-react'
import { addMinutes } from 'date-fns'
// Local
import scheduleEncounter from './scheduleEncounter'
import {
  DEFAULT_PRACTITIONER,
  shouldRenderReskin2025
} from '../../../constant'
import If from '../if'
import ReveleerButton from '../ReveleerButton'

type ScheduleButtonProps = {
  encounterId: string
  label: string
  setIsModalShowing: Dispatch<SetStateAction<boolean>>
  setEncounterIdState: Dispatch<SetStateAction<string>>
  isScheduleCallBeingMade: boolean,
  setIsScheduleCallBeingMade: Dispatch<SetStateAction<boolean>>,
  isOptum: boolean
}

// starting from now, return the next Date at the 0 or 30 minute mark
function findNextThirtyMinuteSlot(): Date {
  const now = new Date()
  const minutes = now.getMinutes()
  if (minutes in [ 0, 30 ]) {
    return now
  }
  if (minutes < 30) {
    return addMinutes(now, 30 - minutes)
  }
  return addMinutes(now, 60 - minutes)
}

function ScheduleButton(props: ScheduleButtonProps) {
  const {
    encounterId,
    label,
    setIsModalShowing,
    setEncounterIdState,
    isScheduleCallBeingMade,
    setIsScheduleCallBeingMade,
    isOptum
  } = props
  return (
    <>
      <If isTrue={ !shouldRenderReskin2025 }>
        <Button
          id="schedule-button"
          compact
          content={ label }
          disabled={ isScheduleCallBeingMade }
          onClick={ () => {
            if (isOptum) {
              const timeSlot = findNextThirtyMinuteSlot()
              scheduleEncounter({
                setIsScheduleCallBeingMade,
                practitionerId: DEFAULT_PRACTITIONER.OPTUM,
                setEncounterIdState,
                encounterId,
                date: timeSlot
              })
            } else {
              setEncounterIdState(encounterId)
              setIsModalShowing(true)
            }
          } }
        />
      </If>
      <If isTrue={ shouldRenderReskin2025 }>
        <ReveleerButton
          buttonLabel={ label }
          buttonSize="small"
          buttonType="secondary"
          id="schedule-button"
          isDisabled={ isScheduleCallBeingMade }
          onClick={ () => {
            if (isOptum) {
              const timeSlot = findNextThirtyMinuteSlot()
              scheduleEncounter({
                setIsScheduleCallBeingMade,
                practitionerId: DEFAULT_PRACTITIONER.OPTUM,
                setEncounterIdState,
                encounterId,
                date: timeSlot
              })
            } else {
              setEncounterIdState(encounterId)
              setIsModalShowing(true)
            }
          } }
          type="button"
        />
      </If>
    </>
  )
}

export default ScheduleButton
